import { BYO_MARKETS_REQUEST, BYO_MARKETS_SUCCESS, BYO_MARKET_FETCHING_STARTED } from '../constants';
export const getMarkets = (locale, eventId, useBYOFreedom) => ({
    type: BYO_MARKETS_REQUEST,
    payload: {
        locale,
        eventId,
        useBYOFreedom,
    },
});
export const marketFetchingStarted = () => ({
    type: BYO_MARKET_FETCHING_STARTED,
});
export const saveMarkets = (markets) => ({
    type: BYO_MARKETS_SUCCESS,
    payload: markets,
});
